import React from 'react';

import { ChevronLeft, HomeLine } from '@flipdish/ui-icons';
import { Breadcrumbs } from '@flipdish/ui-library/components/molecules/Breadcrumbs';
import { Translate } from 'react-localize-redux';
import { useHistory } from 'react-router-dom';

interface PageHeaderProps {
  appId: string;
  accountName: string;
}

const PageHeader = ({ appId, accountName }: PageHeaderProps) => {
  const history = useHistory();

  return (
    <div className="flex flex-col gap-4">
      <button
        onClick={() => history.goBack()}
        className="sm:hidden flex items-center gap-1 text-sm font-semibold text-quaternary hover:text-secondary"
      >
        <ChevronLeft className="h-4 w-4" />
        <span>
          <Translate id="Back" />
        </span>
      </button>

      <div className="hidden sm:block">
        <Breadcrumbs>
          <Breadcrumbs.Item href={`/${appId}`} icon={HomeLine} />
          <Breadcrumbs.Item href={`/${appId}/finance/bank-accounts`}>
            <Translate id="Bank_accounts" />
          </Breadcrumbs.Item>
          <Breadcrumbs.Item>{accountName}</Breadcrumbs.Item>
        </Breadcrumbs>
      </div>

      <h1 className="text-xl font-semibold text-primary">{accountName}</h1>
    </div>
  );
};

export default PageHeader;
